import {
  Button,

  Input,

  LoadingIndicator,
  Modal,
  ReactSelect,

  Typography,
} from "@anchor/react-components/dist/lib/components";
import React, { useEffect, useState } from "react";
import ButtonGenerator from "../ButtonFactory/ButtonGenerator";
import { uid } from "uid";
import axios from "axios";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../auth/authConfig";
import { Table } from "react-bootstrap";
import { RiEdit2Line } from "react-icons/ri";
import { MdDeleteForever } from "react-icons/md";
import { postmortemApiEndpoint } from "../../config";
import { ACTION_CATEGORIES, HORIZONTAL_VERTICAL_FIX_OPTIONS } from "../../constants/actionCategories";
import { getActionCategory } from "../../Utils/actionCategorizer";
import { MacDataServices } from "../../services/macDataServices";
import { useFetchWithRetry } from "../../Utils/fetchWithRetry";
import Select from "react-select";

// Helper function to get category labels from values
const getCategoryLabels = (categoryValues) => {
  if (!categoryValues || !Array.isArray(categoryValues)) return "";

  const allOptions = ACTION_CATEGORIES.flatMap(cat => cat.options);
  const labels = categoryValues
    .map(val => {
      const option = allOptions.find(opt => opt.value === val);
      return option ? option.label : val;
    })
    .filter(Boolean);

  return labels.join(", ");
};




function JiraModal({
  jiraTickets,
  handleModal,
  modalOpen,
  onSave,
  currentJiraTickets,
  setCurrentJiraTickets,
}) {
  const [firstId, setFirstId] = useState(uid());
  const [numberOfTickets, setNumberOfTickets] = useState(
    jiraTickets.length > 0 ? jiraTickets.length : 1
  );

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const { instance, accounts } = useMsal();
  const { fetchWithRetry } = useFetchWithRetry();

  const [jiraLink, setJiraLink] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [platformPortFolio, setPlatformPortFolio] = useState([]); //
  const [selectedPlatformPortFolio, setSelectedPlatformPortFolio] = useState({ id: "", label: "", value: "" })
  const [platforms, setPlatforms] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedPlatform, setSelectedPlatform] = useState({ id: "", label: "", value: "" });
  const [selectedProduct, setSelectedProduct] = useState({ id: "", label: "", value: "" });
  const [loadingPlatforms, setLoadingPlatforms] = useState(false);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [selectedHorizontalVerticalFix, setSelectedHorizontalVerticalFix] = useState(null);
  // Action category is now auto-assigned; no manual selection required

  const { fetchPortfolioData, fetchPlatformData, fetchProductData } = MacDataServices();




  const validateTicket = async (ticketId) => {
    setLoading(true);
    setError(false);
    try {
      const apiEndpoint = postmortemApiEndpoint;
      const url = apiEndpoint + "/jira/" + jiraLink;
      const response = await fetchWithRetry(url, 'JIRA_TICKET', 3, 1000);
      setLoading(false);
      setCurrentJiraTickets((currentJiraTickets) => [
        ...currentJiraTickets,
        {
          jiraid: [jiraLink],
          status: response.jiraStatus,
          assignee: response.assignee,
          owners: [response.reporter].filter(
            (item) => item !== undefined
          ),
          description:
            response.description === "null"
              ? "No Description has been given"
              : response.description,
          duedate: dueDate,
          platformPortfolio: selectedPlatformPortFolio.value,
          actionCategory: [getActionCategory({ description: response.description || '', incidentTitle: '' })],
          horizontalVerticalFix: selectedHorizontalVerticalFix || null,
          jiraPlatform: selectedPlatform?.value || null,
          jiraProduct: selectedProduct?.value || null,
        },
      ]);
      setJiraLink("");
      setDueDate("");
      setSelectedPlatformPortFolio({ id: "", label: "", value: "" });
      setSelectedPlatform({ id: "", label: "", value: "" });
      setSelectedProduct({ id: "", label: "", value: "" });
      setSelectedHorizontalVerticalFix(null);
    } catch (responseObject) {
      setLoading(false);
      if (responseObject.response?.status === 502 || (responseObject.message && responseObject.message.includes('502'))) {
        setError(true);
      } else {
        console.log("Unknown error");
        console.error(responseObject);
      }
    }
  };

  const editJiraTicket = (jiraId) => {
    const index = currentJiraTickets.findIndex(
      (ticket) => ticket.jiraid[0] === jiraId
    );

    if (index !== -1) {
      const ticket = currentJiraTickets[index];
      setJiraLink(ticket.jiraid[0]);
      setDueDate(ticket.duedate);
      
      // Find portfolio by name to get its ID
      const portfolio = platformPortFolio.find(p => p.value === ticket.platformPortfolio);
      if (portfolio) {
        setSelectedPlatformPortFolio({ id: portfolio.id, label: portfolio.label, value: portfolio.value });
      }
      
      setSelectedHorizontalVerticalFix(ticket.horizontalVerticalFix || null);
      
      // Restore platform and product selections
      if (ticket.jiraPlatform) {
        setSelectedPlatform({ id: ticket.jiraPlatform, label: ticket.jiraPlatform, value: ticket.jiraPlatform });
      }
      if (ticket.jiraProduct) {
        setSelectedProduct({ id: ticket.jiraProduct, label: ticket.jiraProduct, value: ticket.jiraProduct });
      }

      // actionCategory is auto-assigned; nothing to restore here

      setCurrentJiraTickets((currentJiraTickets) =>
        currentJiraTickets.filter((ticket) => ticket.jiraid[0] !== jiraId)
      );
    }
  };

  const deleteJiraTicket = (jiraId) => {
    setCurrentJiraTickets((currentJiraTickets) =>
      currentJiraTickets.filter((ticket) => ticket.jiraid[0] !== jiraId)
    );
  };

  useEffect(() => {
    const apiEndpoint = postmortemApiEndpoint;
    (async () => {
      try {
        const response = await fetchPortfolioData(apiEndpoint);
        if (response) {
          try {
            setPlatformPortFolio(response.map(portfolio => ({
              id: portfolio.portfolioId,
              label: portfolio.portfolioName,
              value: portfolio.portfolioName
            })));
          } catch (error) {
            console.error("Error setting platform portfolio:", error);
          }
        } else {
          console.log("Unknown error");
        }
      } catch (responseObject) {
        console.error("RESPONSE OBJECT ", responseObject);
      }
    })();
  }, [modalOpen]);

  // Fetch platforms when portfolio is selected
  useEffect(() => {
    if (selectedPlatformPortFolio?.id) {
      const fetchPlatforms = async () => {
        setLoadingPlatforms(true);
        try {
          const apiEndpoint = postmortemApiEndpoint;
          const platformsData = await fetchPlatformData(apiEndpoint, selectedPlatformPortFolio.id);
          setPlatforms(platformsData.map(platform => ({
            id: platform.platformId,
            label: platform.platformName,
            value: platform.platformName
          })));
        } catch (error) {
          console.error("Error fetching platforms:", error);
          setPlatforms([]);
        } finally {
          setLoadingPlatforms(false);
        }
      };
      fetchPlatforms();
    } else {
      setPlatforms([]);
      setSelectedPlatform({ id: "", label: "", value: "" });
    }
  }, [selectedPlatformPortFolio]);

  // Fetch products when platform is selected
  useEffect(() => {
    if (selectedPlatform?.id) {
      const fetchProducts = async () => {
        setLoadingProducts(true);
        try {
          const apiEndpoint = postmortemApiEndpoint;
          const productsData = await fetchProductData(apiEndpoint, selectedPlatform.id);
          setProducts(productsData.map(product => ({
            id: product.id,
            label: product.label,
            value: product.value
          })));
        } catch (error) {
          console.error("Error fetching products:", error);
          setProducts([]);
        } finally {
          setLoadingProducts(false);
        }
      };
      fetchProducts();
    } else {
      setProducts([]);
      setSelectedProduct({ id: "", label: "", value: "" });
    }
  }, [selectedPlatform]);

  return (
    <div>
      <Modal
        width="1200"
        height={"400"}
        max-height="200"
        backdropcloseactiondisabled={true}
        actions={{
          primaryAction: <Button label="OK" onClick={() => onSave([...currentJiraTickets])} appearance="alt" />,
          // secondaryAction: (
          //   <Button label="Back" onClick={handleModal} variant="outlined" />
          // ),
        }}
        heading=<Typography
          variant="h2"
          fontStyle="bold"
          style={{ fontSize: "30px", textAlign: "center" }}
        >
          Jira Ticket
        </Typography>
        onClose={handleModal}
        showCloseIcon={false}
        open={modalOpen}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",

            paddingLeft: "20px",
            paddingRight: "20px",
            paddingBottom: "10px",
            marginTop: "10px",
            // position:"fixed",
            // width:"40%",
            // zIndex:100
            // top:0
          }}
        >
          {/* {jiraTickets.length === 0 && */}
          <div style={{ marginRight: "20px", width: "25%", height: "100px" }}>
            <Input
              onChange={(e) => {
                setError(false);
                setJiraLink(e.target.value);
              }}
              value={jiraLink}
              placeholder="Jira Ticket"
              name="ticket"
              error={error}
              errorMessage="Invalid Jira Ticket"
              label="Jira Ticket"
            />
          </div>
          <div style={{ marginRight: "20px", width: "25%" }}>
            <Input
              onChange={(e) => {
                // setError(false);
                setDueDate(e.target.value);
              }}
              value={dueDate}
              placeholder="Due Date"
              name="ticket"
              label="Due Date"
              // error={error}
              // errorMessage="Invalid Jira Ticket"
              type="date"
            />
          </div>

          <div style={{ width: "25%", marginRight: "20px" }}>

            <ReactSelect
              // style={{background:"none"}}
              // disabled={incidentChangeRef.length === 0}
              maxMenuHeight={150}
              className="react-select"
              closeMenuOnSelect
              customNoOptionsMessage={<p>Not a valid option</p>}
              // error={error}
              errorMessage="{errorText}"
              fit="medium"

              id="selectAction"
              isSearchable
              label="Portfolio"
              name="platformPortfolio"
              onChange={(e) => setSelectedPlatformPortFolio(e)}
              onInputChange={function noRefCheck() { }}
              onMenuClose={function noRefCheck() { }}
              onMenuOpen={function noRefCheck() { }}
              onOptionUpdate={function noRefCheck() { }}
              options={platformPortFolio}
              orientation="vertical"
              // placeholder={incidentChangeRef.length === 0 ? "Please enter the INC/CHG Number first" : "Choose Action Script"}
              required
              suggestType="static"
              // variant
              // isLoading={}
              // tooltipDescription="H"
              value={selectedPlatformPortFolio}
              variant="default"
              width={100}


            />

          </div>

          <div style={{ width: "25%", marginRight: "20px" }}>
            <ReactSelect
              maxMenuHeight={150}
              className="react-select"
              closeMenuOnSelect
              customNoOptionsMessage={<p>Not a valid option</p>}
              fit="medium"
              id="selectPlatform"
              isSearchable
              label="Platform"
              name="jiraPlatform"
              onChange={(e) => setSelectedPlatform(e || { id: "", label: "", value: "" })}
              onInputChange={function noRefCheck() { }}
              onMenuClose={function noRefCheck() { }}
              onMenuOpen={function noRefCheck() { }}
              onOptionUpdate={function noRefCheck() { }}
              options={platforms}
              orientation="vertical"
              suggestType="static"
              value={selectedPlatform}
              variant="default"
              width={100}
              isClearable
              isLoading={loadingPlatforms}
              isDisabled={!selectedPlatformPortFolio?.id}
            />
          </div>

          <div style={{ width: "25%", marginRight: "20px" }}>
            <ReactSelect
              maxMenuHeight={150}
              className="react-select"
              closeMenuOnSelect
              customNoOptionsMessage={<p>Not a valid option</p>}
              fit="medium"
              id="selectProduct"
              isSearchable
              label="Product"
              name="jiraProduct"
              onChange={(e) => setSelectedProduct(e || { id: "", label: "", value: "" })}
              onInputChange={function noRefCheck() { }}
              onMenuClose={function noRefCheck() { }}
              onMenuOpen={function noRefCheck() { }}
              onOptionUpdate={function noRefCheck() { }}
              options={products}
              orientation="vertical"
              suggestType="static"
              value={selectedProduct}
              variant="default"
              width={100}
              isClearable
              isLoading={loadingProducts}
              isDisabled={!selectedPlatform?.id}
            />
          </div>

          <div style={{ width: "25%", marginRight: "20px" }}>
            <ReactSelect
              maxMenuHeight={150}
              className="react-select"
              closeMenuOnSelect
              customNoOptionsMessage={<p>Not a valid option</p>}
              fit="medium"
              id="selectHorizontalVerticalFix"
              isSearchable
              label="Horizontal/Vertical Fix"
              name="horizontalVerticalFix"
              onChange={(e) => setSelectedHorizontalVerticalFix(e?.value || null)}
              onInputChange={function noRefCheck() { }}
              onMenuClose={function noRefCheck() { }}
              onMenuOpen={function noRefCheck() { }}
              onOptionUpdate={function noRefCheck() { }}
              options={HORIZONTAL_VERTICAL_FIX_OPTIONS}
              orientation="vertical"
              suggestType="static"
              value={HORIZONTAL_VERTICAL_FIX_OPTIONS.find(opt => opt.value === selectedHorizontalVerticalFix)}
              variant="default"
              width={100}
              isClearable
            />
          </div>

          <ButtonGenerator
            appearance="default"
            id="primary"
            // justifyItems="center"
            label="Validate"
            name="primary"
            onClick={() => validateTicket(jiraLink)}
            title="Prev"
            variant="filledAlt"
            style={{
              marginLeft: "20px",
              marginTop: "29px",
              flexShrink: 0,
              whiteSpace: "nowrap",
              minWidth: "fit-content",
            }}
            disabled={
              dueDate.length == 0 ||
              jiraLink.length == 0 ||
              selectedPlatformPortFolio.id === ""
            }

          // disabled={currentJiraTickets.length === 1}
          //   disabled={!jiraLink}
          />
          {/* } */}
        </div>

        {/*  */}
        {loading ? (
          <LoadingIndicator
            appearance="default"
            fit="large"
            id="testing"
            label="Validating.."
            variant="spinner"
            style={{ background: "none" }}
          />
        ) : (
          currentJiraTickets &&
          currentJiraTickets.length > 0 && (
            <div style={{ padding: "0 20px" }}>
              <Table size="sm" striped bordered hover>
                <thead>
                  <tr>
                    <th>Action ID</th>
                    <th style={{ width: "12rem", maxWidth: "12rem" }}>
                      Summary
                    </th>
                    <th>Assigned to</th>
                    {/* <th style={{ width: "8rem", maxWidth: "8rem" }}>Owners</th> */}
                    <th>Portfolio</th>
                    <th>Platform</th>
                    <th>Product</th>
                    <th>Fix Type</th>
                    <th>Status</th>
                    <th>Due Date</th>
                    <th>Delete/Edit</th>
                  </tr>
                </thead>
                <tbody>
                  {currentJiraTickets.map((ticket, index) => (
                    <tr key={index}>
                      <td>{ticket.jiraid[0]}</td>
                      <td
                        style={{
                          width: "12rem",
                          maxWidth: "12rem",
                          wordBreak: "break-all",
                        }}
                      >
                        {ticket.description}
                      </td>
                      <td>{ticket.assignee}</td>
                      {/* <td style={{ width: "8rem", maxWidth: "8rem" }}>
                        {ticket.owners}
                      </td> */}
                      <td style={{ width: "10rem", maxWidth: "10rem" }}>{ticket.platformPortfolio ? ticket.platformPortfolio : ""}</td>
                      <td>{ticket.jiraPlatform || "-"}</td>
                      <td>{ticket.jiraProduct || "-"}</td>
                      <td>{ticket.horizontalVerticalFix || "-"}</td>
                      <td>{ticket.status}</td>
                      <td>{ticket.duedate}</td>
                      <td>
                        <div
                          style={{
                            display: "flex",
                            // justifyContent: "",
                          }}
                        >
                          <div
                            style={{ marginRight: "20px", paddingLeft: "20px" }}
                          >
                            <RiEdit2Line
                              onClick={() => editJiraTicket(ticket.jiraid[0])}
                              className="editIcons"
                              style={{}}
                            />
                          </div>

                          <div>
                            <MdDeleteForever
                              onClick={() => deleteJiraTicket(ticket.jiraid[0])}
                              className="editIcons"
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )
        )}
      </Modal>{" "}
    </div>
  );
}

export default JiraModal;
